interface ImportTemplateButtonProps {
    onClick: () => void;
    loading: boolean
}

const ImportTemplateButton: React.FC<ImportTemplateButtonProps> = ({ onClick, loading }) => {
    return (
        <button className={`py-2 px-3 position-absolute top-65px d-flex gap-2 align-items-center cursor-pointer right-40 z-9 bg-black border rounded-2 ${loading && 'opacity-60'}`}
            onClick={onClick}
            disabled={loading}
        >
            {!loading && <i className='fe fe-upload'></i>}
            {loading && <div className='spin__loader' />}
            <span>Import Bus</span>
        </button>
    )
}

export default ImportTemplateButton